import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The Library section is now Regulation. Old links (bookmarks, chat
 * transcripts) keep working through this redirect.
 */
export const Route = createFileRoute("/library")({
  beforeLoad: ({ location }) => {
    throw redirect({
      to: location.pathname.replace(/^\/library/, "/compliance") || "/compliance",
      replace: true,
    });
  },
});
